export default __webpack_public_path__ + "static/media/Guess where this video was taken .138bb0da.mp4";